// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio-module--radio--1baHX","radio__caption":"radio-module--radio__caption--1fqgl"};